import React, { Component } from "react";

class Community extends Component {
  render() {
    return (
      <div>
        <p>
          We invite you to visit our{" "}
          <a href="https://community.checkpoint.com/docs/DOC-3472-smartconsole-extensions">
            CheckMates developers community
          </a>{" "}
          to see Open-Source extensions examples, questions, discussions and
          more.
        </p>
        <p>
          Contact us by email{" "}
          <a href="mailto:extensions@checkpoint.com">
            extensions@checkpoint.com
          </a>{" "}
          (CheckMates posts will be addressed more frequently).
        </p>
      </div>
    );
  }
}

export default Community;
